import React from "react";
import cx from "classnames";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: "primary" | "secondary";
    stretch?: boolean;
};

const variants: Record<NonNullable<Props["variant"]>, string> = {
    primary: "text-black bg-[#ebebeb] hover:bg-black hover:text-white",
    secondary: "text-white bg-black",
};

export const Button: React.FC<Props> = ({
    variant = "primary",
    stretch,
    className,
    ...props
}) => {
    return (
        <button
            type="button"
            className={cx(
                "transition rounded-xl",
                stretch ? "py-4" : "p-4",
                variants[variant],
                className
            )}
            {...props}
        />
    );
};
